import { createSelector } from '@reduxjs/toolkit'
import { getCartEvaluationItems } from 'checkout/selectors/getCartEvaluationItems'

/**
 * Whether the whole-cart evaluation requires an inline trip request form for the given vertical,
 * or for any vertical when no type is given.
 */
export function makeSelectCartEvaluationRequiresTripRequestForm(
  itemPolicyType?: App.BusinessTraveller.ItemPolicyType,
) {
  return createSelector(
    (state: App.State) => state.businessTraveller.cartEvaluation.result?.approval.required,
    getCartEvaluationItems,
    (approvalRequired, cartEvaluationItems): boolean => {
      return (
        !!approvalRequired &&
        cartEvaluationItems.data.some(
          (item) => !itemPolicyType || item.itemPolicyLookup.itemPolicyType === itemPolicyType,
        )
      )
    },
  )
}
